import React from 'react';
import { getTheme } from '../components/theme-controller';
import { connect } from 'react-redux';
import get from 'lodash/get';

const Icon = ({ primaryColor, secondaryColor, dispatch, ...props }) => {
	const theme = getTheme(primaryColor, secondaryColor);
	return (
		<svg
			{...props}
			width="16px"
			height="14px"
			viewBox="0 0 16 14"
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
		>
			<title>B28AFAAF-4981-417C-AA56-ED872A41D397@3x</title>
			<desc>Created with sketchtool.</desc>
			<g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
				<g
					id="Icon-Set"
					transform="translate(-348.000000, -219.000000)"
					fill={theme.textColor}
					fillRule="nonzero"
				>
					<g id="noun_cart_927434-copy" transform="translate(348.000000, 219.000000)">
						<g id="Group" transform="translate(0.363636, 0.000000)">
							<path
								d="M0.509150778,0.062597284 C0.227979869,0.062597284 5.98690909e-05,0.294748395 5.98690909e-05,0.581115802 C5.98690909e-05,0.867484938 0.227979869,1.09963432 0.509150778,1.09963432 L2.20082596,1.09963432 C3.04340536,3.22512815 3.87334233,5.35450914 4.70915081,7.48389877 L3.9402199,9.36892099 C3.87580293,9.52608395 3.89392657,9.71558519 3.98690354,9.85712346 C4.07989748,9.99866173 4.24497869,10.0880025 4.41218112,10.0872938 L12.8970296,10.0872938 C13.1659823,10.0910963 13.4133666,9.84274321 13.4133666,9.56877531 C13.4133666,9.29480741 13.1659823,9.04638519 12.8970296,9.05025679 L5.17581748,9.05025679 L5.61597748,7.98081235 L13.7879387,7.31645185 C14.0018417,7.29934074 14.195466,7.12962963 14.2439993,6.91676049 L15.2621811,2.42293679 C15.3287702,2.12025679 15.0682344,1.78998123 14.7636963,1.79099235 L3.56899081,1.79099235 L3.01747566,0.386671358 C2.94196051,0.196579012 2.74684293,0.0626041975 2.54551445,0.062597284 L0.509150778,0.062597284 Z M3.97733263,2.82802938 L14.1220381,2.82802938 L13.3318781,6.31722691 L5.59476536,6.94377531 L3.97733263,2.82802938 Z M6.10915081,10.4329728 C5.17797263,10.4329728 4.41218112,11.2129284 4.41218112,12.1613679 C4.41218112,13.1097901 5.17797263,13.889763 6.10915081,13.889763 C7.04032899,13.889763 7.80612051,13.1097901 7.80612051,12.1613679 C7.80612051,11.2129457 7.04032899,10.4329728 6.10915081,10.4329728 Z M11.2000599,10.4329728 C10.2688817,10.4329728 9.50309021,11.2129457 9.50309021,12.1613679 C9.50309021,13.1097901 10.2688817,13.889763 11.2000599,13.889763 C12.1312381,13.889763 12.8970296,13.1097901 12.8970296,12.1613679 C12.8970296,11.2129284 12.1312381,10.4329728 11.2000599,10.4329728 Z M6.10915081,11.4700099 C6.4900696,11.4700099 6.78793869,11.7733951 6.78793869,12.1613679 C6.78793869,12.5493407 6.4900696,12.8527259 6.10915081,12.8527259 C5.72826596,12.8527259 5.43036293,12.5493235 5.43036293,12.1613679 C5.43036293,11.7734123 5.72826596,11.4700099 6.10915081,11.4700099 Z M11.2000599,11.4700099 C11.5809448,11.4700099 11.8788478,11.7734123 11.8788478,12.1613679 C11.8788478,12.5493235 11.5809448,12.8527259 11.2000599,12.8527259 C10.8191411,12.8527259 10.521272,12.5493407 10.521272,12.1613679 C10.521272,11.7733951 10.8191411,11.4700099 11.2000599,11.4700099 Z"
								id="Shape"
							></path>
						</g>
					</g>
				</g>
			</g>
		</svg>
	);
};

const mapStateToProps = state => ({
	primaryColor: get(state, 'user.user.preferences.color_scheme.primary'),
	secondaryColor: get(state, 'user.user.preferences.color_scheme.secondary'),
});

export default connect(mapStateToProps)(Icon);
